import React from 'react';

export default function FirmOfficesWidget({ firm }) {
    const offices = firm.offices || [];
    if (offices.length === 0) return <span className="text-sm text-gray-400">No offices</span>;
    return (
        <div className="space-y-1.5">
            {offices.map((o, i) => (
                <div key={i} className="flex items-center gap-2 px-2 py-1.5 bg-gray-50 rounded text-sm text-gray-800">
                    <svg className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                    <span className="flex-1 truncate">{[o.city, o.state, o.country].filter(Boolean).join(', ')}</span>
                    {o.isPrimary && <span className="text-[9px] font-medium text-emerald-700 bg-emerald-50 px-1.5 py-0.5 rounded border border-emerald-200 flex-shrink-0">HQ</span>}
                </div>
            ))}
        </div>
    );
}
